import getEnv from 'zg_utils/getEnv';

const keys = ['sentryDsn', 'sentryEnvironment', 'membersAppUrl'];

export default getEnv(keys);
